import { useEffect } from "react";

export const RegisterPage = () => {
    useEffect(() => {
        window.location.href = "https://www.airmeet.com/e/4c27f780-7517-11ef-a2d5-478ed46623b6";
    }, []);

    return null;
};
